import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Import action types
import { GET_ERRORS, GET_SUCCESS } from "../actions/types";

// Initial state of the service reducer
const initialState = {
  serviceData: {
    serviceName: "",
    serviceTellUs: "",
    serviceRate: 0,
    serviceRateUs: "",
    servicePhotoUrl: "",
    servicePresentation: "",
    serviceType: "virtual",
    servicePortfolios: [],
    serviceCertifications: [],
    location: null,
  },
};

// Service reducer function
const serviceReducer = (state = initialState, action) => {
  switch (action.type) {
    // If action type is GET_SUCCESS or GET_ERRORS
    case GET_SUCCESS:
    case GET_ERRORS:
      // Return new state with updated service data
      return {
        ...state,
        serviceData: action.payload,
      };
    // Default case
    default:
      return state;
  }
};

const persistConfig = {
  keyPrefix: "tradetribe-",
  // Must be unique. Previously this was "auth", colliding with authReducer's
  // persisted state — the service state overwrote the auth state in storage,
  // so after onboarding/reload `isAuthenticated` came back false (header showed
  // logged-out even though the user was logged in).
  key: "service",
  storage,
};

export default persistReducer(persistConfig, serviceReducer);
